<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back"><mat-icon
            color="primary">arrow_back_ios</mat-icon></button>
    <h3>{{ patient | patientHeading:'Edit Discharge Record':'Edit Discharge Record' }}</h3>
    <div>
        <button mat-icon-button [disabled]="form.invalid" (click)="saveAdmissionHistory()"
            matTooltip="Save Discharge Record"><mat-icon
                [color]="form.invalid ? '' : 'primary'">save</mat-icon></button>
    </div>
</mat-toolbar>

<div class="discharge-details-container" id="details">
    <form [formGroup]="form">
        <mat-card>
            <mat-form-field appearance="outline">
                <mat-label>Admission Date</mat-label>
                <input matInput [matDatepicker]="admissionDatePicker" formControlName="admissionDate"
                    placeholder="DD/MM/YYYY" [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="admissionDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #admissionDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Discharge Date</mat-label>
                <input matInput [matDatepicker]="dischargeDatePicker" formControlName="dischargeDate"
                    placeholder="DD/MM/YYYY" [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dischargeDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dischargeDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Discharge Summary</mat-label>
                <textarea matInput cdkTextareaAutosize="false" rows="20" formControlName="dischargeSummary"
                    #dischargeSummaryTextarea></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="form.get('dischargeSummary')?.value" class="full-width">
                <textarea matInput placeholder="Instruct MedicAI" cdkTextareaAutosize="true" rows="1"
                    #dischargeSummaryAutosize="cdkTextareaAutosize" formControlName="dischargeSummaryPrompt"
                    (keydown.enter)="aiPerformUserPrompt($event, 'dischargeSummary')"></textarea>
                <button matSuffix mat-icon-button (click)="aiPerformUserPrompt(null, 'dischargeSummary')">
                    <mat-icon>send</mat-icon>
                </button>
                <mat-hint>
                    Customize your output
                    <mat-icon
                        matTooltip="You can say things like, output as paragraphs, or add additional information to X heading.">info</mat-icon>
                </mat-hint>
            </mat-form-field>

            <div class="actions" *ngIf="form.get('dischargeSummary')?.value">
                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="secondary" [matMenuTriggerFor]="downloadMenu">
                        <mat-icon>file_download</mat-icon> Download PDF
                    </button>
                    <mat-menu #downloadMenu="matMenu" class="p-10">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker></mat-datepicker>
                        </mat-form-field>

                        <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('doctor')">
                            Download PDF <mat-icon>file_download</mat-icon>
                        </button>
                    </mat-menu>
                </ng-container>
                <ng-template #cantSign>
                    <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('doctor')">
                        Download PDF <mat-icon>file_download</mat-icon>
                    </button>
                </ng-template>
                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="primary" matTooltip="Send this discharge summary via email" *ngIf="!stateUnit"
                        (click)="sendDischargeSummary('doctor')">
                        <mat-icon>mail</mat-icon> Send Summary
                    </button>
                    <mat-menu #emailMenu="matMenu" class="p-10">
                        <div mat-menu-content (click)="$event.stopPropagation()">
                            <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                                (click)="$event.stopPropagation()">
                                {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                            </mat-checkbox>
                            <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                                <mat-label>Select Doctor's Signature</mat-label>
                                <mat-select formControlName="selectedDoctor">
                                    <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                        {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                                <mat-label>Document Date</mat-label>
                                <input matInput [matDatepicker]="pdfDatePicker_email1" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                                <mat-datepicker-toggle matSuffix [for]="pdfDatePicker_email1"></mat-datepicker-toggle>
                                <mat-datepicker #pdfDatePicker_email1></mat-datepicker>
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="full-width"
                                (click)="sendDischargeSummary('doctor')"
                                matTooltip="Send this discharge summary via email">
                                <mat-icon>send</mat-icon> Send Email
                            </button>
                        </div>
                    </mat-menu>
                </ng-container>
                <ng-template #cantSign>
                    <button mat-raised-button color="primary" class="full-width" *ngIf="!stateUnit"
                        (click)="sendDischargeSummary('doctor')" matTooltip="Send this discharge summary via email">
                        <mat-icon>send</mat-icon> Send Email
                    </button>
                </ng-template>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Patient Summary</mat-label>
                <textarea matInput cdkTextareaAutosize="false" rows="20" formControlName="patientDischargeSummary"
                    #patientDischargeSummaryTextarea></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="form.get('patientDischargeSummary')?.value" class="full-width">
                <textarea matInput placeholder="Instruct MedicAI" cdkTextareaAutosize="true" rows="1"
                    #patientDischargeSummaryAutosize="cdkTextareaAutosize"
                    formControlName="patientDischargeSummaryPrompt"
                    (keydown.enter)="aiPerformUserPrompt($event, 'patientDischargeSummary')"></textarea>
                <button matSuffix mat-icon-button (click)="aiPerformUserPrompt(null, 'patientDischargeSummary')">
                    <mat-icon>send</mat-icon>
                </button>
                <mat-hint>
                    Customize your output
                    <mat-icon
                        matTooltip="You can say things like, output as paragraphs, or add additional information to X heading.">info</mat-icon>
                </mat-hint>
            </mat-form-field>

            <div class="actions" *ngIf="form.get('patientDischargeSummary')?.value">
                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="secondary" [matMenuTriggerFor]="downloadMenu">
                        <mat-icon>file_download</mat-icon> Download PDF
                    </button>
                    <mat-menu #downloadMenu="matMenu" class="p-10">
                        <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnPdf" class="checkbox"
                            (click)="$event.stopPropagation()">
                            {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                        </mat-checkbox>
                        <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Select Doctor's Signature</mat-label>
                            <mat-select formControlName="selectedDoctor">
                                <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                    {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="full-width"
                            (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                            <mat-label>Document Date</mat-label>
                            <input matInput [matDatepicker]="pdfDatePicker2" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="pdfDatePicker2"></mat-datepicker-toggle>
                            <mat-datepicker #pdfDatePicker2></mat-datepicker>
                        </mat-form-field>

                        <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('patient')">
                            Download PDF <mat-icon>file_download</mat-icon>
                        </button>
                    </mat-menu>
                </ng-container>
                <ng-template #template>
                    <button mat-raised-button color="primary" class="full-width" (click)="downloadAsPdf('patient')">
                        Download PDF <mat-icon>file_download</mat-icon>
                    </button>
                </ng-template>
                <ng-container *ngIf="canSign; else cantSign">
                    <button mat-raised-button color="primary" matTooltip="Send this discharge summary via email" *ngIf="!stateUnit"
                        [matMenuTriggerFor]="emailMenu">
                        <mat-icon>mail</mat-icon> Send Summary
                    </button>
                    <mat-menu #emailMenu="matMenu" class="p-10 email-menu-panel">
                        <div mat-menu-content (click)="$event.stopPropagation()">
                            <mat-checkbox *ngIf="canSign" formControlName="includeSignatureOnEmail" class="checkbox"
                                (click)="$event.stopPropagation()">
                                {{isPhysician ?'Attach Signature' : 'Attach Doctor\'s Signature'}}
                            </mat-checkbox>
                            <mat-form-field *ngIf="hasSignaturePermission" appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                                <mat-label>Select Doctor's Signature</mat-label>
                                <mat-select formControlName="selectedDoctor">
                                    <mat-option *ngFor="let doctor of groupUsers" [value]="doctor">
                                        {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <app-recipient-search 
                                [patient]="patient"
                                label="Quick Select Recipient"
                                placeholder="Search for recipient..."
                                (recipientSelected)="onRecipientSelected($event)">
                            </app-recipient-search>
                            <mat-form-field appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)">
                                <mat-label>Recipient Name</mat-label>
                                <input matInput formControlName="name">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Recipient Email</mat-label>
                                <input matInput formControlName="email">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width"
                                (keydown)="handleMenuKeydown($event)" (click)="$event.stopPropagation()">
                                <mat-label>Document Date</mat-label>
                                <input matInput [matDatepicker]="pdfDatePicker_email2" formControlName="pdfDate" placeholder="DD/MM/YYYY">
                                <mat-datepicker-toggle matSuffix [for]="pdfDatePicker_email2"></mat-datepicker-toggle>
                                <mat-datepicker #pdfDatePicker_email2></mat-datepicker>
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="full-width"
                                [disabled]="!form.get('email')?.value || form.get('email')?.invalid"
                                (click)="sendDischargeSummary('patient')" matTooltip="Send to this email address">
                                <mat-icon>send</mat-icon> Send Email
                            </button>
                        </div>
                    </mat-menu>
                </ng-container>
                <ng-template #cantSign>
                    <button mat-raised-button color="primary" class="full-width" *ngIf="!stateUnit"
                        [disabled]="!form.get('email')?.value || form.get('email')?.invalid"
                        (click)="sendDischargeSummary('patient')" matTooltip="Send to this email address">
                        <mat-icon>send</mat-icon> Send Email
                    </button>
                </ng-template>
            </div>


            <div class="actions">
                <button mat-raised-button class="ai-feature" (click)="aiGenerateDischargeSummary()"
                    matTooltip="Generate a discharge summary using MedicAI">
                    <mat-icon svgIcon="medic_ai"></mat-icon>
                    {{ form.get('dischargeSummary')?.value ? 'Regenerate': 'Generate'}}
                </button>
            </div>

        </mat-card>
    </form>
</div>

<ng-template #buildRecipientListDialog>
    <h1 mat-dialog-title>Email Recipients</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <app-bulk-email-list-creator #emailListCreator></app-bulk-email-list-creator>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="null">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="emailListCreator.recipientList">Save</button>
    </div>
</ng-template>